var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "questionnaireTableContainer layout-column",
      class: _vm.template.classes,
    },
    [
      _c("div", { staticClass: "flex-hold layout-row" }, [
        _c("div", { staticClass: "questionnaireTableWrapper" }, [
          _c(
            "table",
            { staticClass: "questionnaireTable" },
            _vm._l(_vm.template.cells, function (cell) {
              return _c("questionnaire-table-row", {
                key: cell.id,
                attrs: {
                  template: cell,
                  model: _vm.tableConfig,
                  response: _vm.response,
                },
              })
            }),
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }